/* eslint-disable import/no-unresolved */
import * as React from 'react';
import './index.css';
import { withTranslation } from '@sailor/i18n-mach-pro';
import { CALCULATE_PRICE_STATUS, SHOP_ACTIVITY_TYPE } from '@/src/pages/shop/c_shop/utils/constant';
import IconText from '@/src/components/IconText';
import {
  GoodDetailGroupList, GoodDetailGroupSku, GoodDetailSkuList, SelectedGroupSkuList
} from '../../../../pages/shop/c_shop/component';
import { MultiSkuStore } from '../../Store';
import GroupSkuStepper from './GroupSkuStepper';
import TrackUtils from '../../utils/TrackUtils';

interface IProps {
  groupData: GoodDetailGroupList;
  changeSelectedAttrs: Function;
  skuId: number;
  lab: object; //埋点用
  store: MultiSkuStore;
  sku: GoodDetailSkuList;
  isMeetSillAmount: boolean;
  curSkuDiscountPriceIndex: number;
}

interface IState {
  highLight: boolean;
  itemCountMap: SelectedGroupSkuList[]; //groupSkuList的状态数组
}

const Toast = Mach.requireModule('Toast');

/**
 * 复选选项组的加号icon状态
 */
const groupSkuAddIcon = {
  selectedAbleIcon: 'assets://shop/icon_multi_group_sku_selected_able.png', //已选可点击
  selectedUnableIcon: 'assets://shop/icon_multi_group_sku_selected_unable.png', //已选不可点击
  unselectedAbleIcon: 'assets://shop/icon_multi_group_sku_unselected_able.png', //未选可点击
  unselectedUnableIcon: 'assets://shop/icon_multi_group_sku_unselected_unable.png', //未选不可点击
};
class AttrGroup extends React.Component<any, IState> {
  refArray: any; //groupSku的ref数组

  constructor(props: IProps) {
    super(props);
    const selectedGroupList = this.props.store.getSelectedGroupListBySkuId(this.props.skuId);
    const selectedGroupSkuList = selectedGroupList.find((item) => (item.groupId === this.props.groupData.groupId))?.groupSkuList || [];
    const itemCountMap = this.setItemCountMap(selectedGroupSkuList, this.props.groupData);
    this.state = {
      highLight: false,
      itemCountMap,
    };
  }

  shouldComponentUpdate(nextProps: IProps, nextState: IState): boolean {
    const {
      groupData, changeSelectedAttrs, skuId, isMeetSillAmount, curSkuDiscountPriceIndex
    } = this.props;
    const propChange = nextProps.groupData !== groupData || nextProps.changeSelectedAttrs !== changeSelectedAttrs || nextProps.skuId !== skuId || nextProps.isMeetSillAmount !== isMeetSillAmount || nextProps.curSkuDiscountPriceIndex !== curSkuDiscountPriceIndex;
    // 更新state
    if (propChange) {
      const selectedGroupList = this.props.store.getSelectedGroupListBySkuId(nextProps.skuId);
      const selectedGroupSkuList = selectedGroupList.find((item) => (item.groupId === nextProps.groupData.groupId))?.groupSkuList || [];
      const itemCountMap = this.setItemCountMap(selectedGroupSkuList, nextProps.groupData);
      this.setState({
        itemCountMap,
      });
    }
    return propChange || nextState !== this.state;
  }

  /**
     * 复选group初始化
     * @param selectedGroupList 已选列表
     * @returns
     */
  setItemCountMap = (selectedGroupList: SelectedGroupSkuList[], groupData) => {
    // const { groupData } = this.props;
    const max = groupData.maxNumber;
    const min = groupData.minNumber;
    const tempMap = groupData.groupSkuList;
    this.refArray = Array(tempMap.length).fill(null).map(() => React.createRef());
    const countSum = selectedGroupList.reduce((total, item) => total + (item?.count || 0), 0);
    const isFull = countSum >= max;
    let shouldDisable;
    tempMap.forEach((item) => {
      if (selectedGroupList.length > 0) {
        const index = selectedGroupList.findIndex((i) => {
          if (i && item) {
            return i.groupSkuId === item.groupSkuId;
          } else {
            return false;
          }
        });
        //已选列表里有说明count存在，非复选的话count为1
        const groupSkuCount = index > -1 ? (selectedGroupList[index].count || 1) : 0;
        item.count = groupSkuCount;
        item.status = groupSkuCount > 0 ? 1 : 0;

        if (isFull) {
          item.addIcon = groupSkuCount > 0 ? groupSkuAddIcon.selectedUnableIcon : groupSkuAddIcon.unselectedUnableIcon;
        } else {
          item.addIcon = groupSkuCount > 0 ? groupSkuAddIcon.selectedAbleIcon : groupSkuAddIcon.unselectedAbleIcon;
        }
      } else {
        item.count = 0;
        item.status = 0;
        item.addIcon = groupSkuAddIcon.unselectedAbleIcon;
      }
    });
    //非复选的icon状态处理
    if (selectedGroupList.length > 0) {
      switch (true) {
        // 非必选但到达最大
        case min === 0 && max > 0 && selectedGroupList.length === max:
          shouldDisable = true;
          break;
          // 必选但非单选到达最大
        case min > 0 && max > 1 && selectedGroupList.length === max:
          shouldDisable = true;
          break;
        default:
          shouldDisable = false;
          break;
      }
      if (shouldDisable) {
        tempMap.forEach((item) => {
          item.status = item.status === 0 ? 2 : 1;
        });
      }
    }
    return tempMap;
  }

  hightLightBg = () => {
    this.setState({
      highLight: true,
    });
  }

  render() {
    const { itemCountMap } = this.state;
    const {
      groupData, sku, isMeetSillAmount, curSkuDiscountPriceIndex
    } = this.props;
    const style = this.listUI().style;
    const bgStyle = this.listUI().bgStyle;
    const icon = this.listUI().icon;
    const repeatable = groupData.repeatable;
    return (
      <view className="sku-group">
        <view className="seperator-line" />
        <view className="group-title-container">
          <view style={{ flexDirection: 'column' }}>
            <text className="group-title" content={groupData.groupName} />
            <view>
              <view className="status-btn" style={bgStyle}>
                {icon ? <image className="group-warning-icon" src={icon} /> : <view style={{ width: 6, height: 20 }} />}
                <text
                  className="status-text"
                  style={style}
                  content={this.getStatusText()}
                />
              </view>
            </view>
          </view>
        </view>
        <view className="group-content">
          {itemCountMap.map((item: SelectedGroupSkuList, index: number) => {
            const itemIcon = this.itemIcon(item.groupSkuId);
            const content = this.getItemText(item);
            const isFullDiscount = sku.activityInfoList?.[0]?.activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT;
            const isOriginPricePositive = item.originPrice.amount > 0;
            const curCount = item?.count || 0;
            const addIcon = item?.addIcon || groupSkuAddIcon.unselectedAbleIcon;
            const wholeCount = itemCountMap.reduce((total, item) => total + item.count, 0);
            const disAbleText = (groupData.repeatable === 1) && (curCount === 0) && (wholeCount === groupData.maxNumber);
            const textStyle = { color: (this.itemStatus(item.groupSkuId) === 2 || disAbleText) ? '#808080' : '#222222' };
            return (
            // eslint-disable-next-line react/jsx-key
              <view
                style={{ borderBottom: (index === groupData.groupSkuList.length - 1) ? '0' : '0.6 solid #00000014' }}
                className="group-item"
                onClick={() => { this.clickSkuItem(item); }}
              >
                <view className="group-item-name-cust-container">
                  <text className={disAbleText ? 'group-item-text-disable' : 'group-item-text'} style={textStyle} content={item.name} />
                  {item.calorie?.length > 0 && (
                    <IconText
                      iconSrc="assets://shop/icon_kcal_gray.png"
                      text={item.calorie}
                      containerStyle={{ marginTop: 6 }}
                    />
                  )}
                </view>
                <view className="group-item-padding" style={{ flexShrink: 0 }}>
                  {
                    // 是满折菜品，且达到满折条件，且原价大于0
                    isFullDiscount && isMeetSillAmount && isOriginPricePositive
                      ? (
                        <view className="group-item-price-container">
                          <text className="group-item-discount-price-text" content={`+${item?.discountPriceList?.[curSkuDiscountPriceIndex]?.discountPrice?.displayText}`} />
                          <text className="group-item-min-price-text" content={`+${item?.originPrice.displayText}`} />
                        </view>
                      )
                      : <text className="group-item-price-text" content={content} />
                  }
                  {!(repeatable && item) ? <image className="group-item-status-icon" src={itemIcon} />
                    : (
                      <view>
                        <GroupSkuStepper
                          ref={this.refArray[index]}
                          addIcon={addIcon}
                          curCount={curCount}
                        />
                      </view>
                    )}
                </view>
                {/* 使用透明的absolute来扩大按钮热区 */}
                {repeatable && (
                  <view
                    className="add-btn-hitslop" onClick={() => {
                      this.calRepeatableSku(item, true);
                    }}
                  />
                )}
                {repeatable && curCount > 0 && (
                  <view
                    className="dec-btn-hitslop" onClick={() => {
                      this.calRepeatableSku(item, false);
                    }}
                  />
                )}
              </view>
            );
          })}
        </view>
      </view>
    );
  }

  /**
     * 点击选项组内sku加减号
     * @param groupSkuItem 当前加减的sku
     * @param isAdd 是否是加购（true加购false减购）
     * @param index 当前item的index
     * @returns
     */
  private calRepeatableSku = (groupSkuItem: GoodDetailGroupSku, isAdd: boolean) => {
    const {
      groupData, changeSelectedAttrs, lab, store
    } = this.props;
    const { itemCountMap } = this.state;
    const curSumCount = itemCountMap.reduce((total, obj) => total + obj.count, 0);
    const isFull = curSumCount >= groupData.maxNumber;
    // const {current} = this.refArray[index];
    // let firstAdd, decToNone;

    if ((isFull && isAdd) || (!isAdd && curSumCount <= 0) || (store.getCalStatus() === CALCULATE_PRICE_STATUS.LOADING)) {
      return;
    }

    TrackUtils.stepperMC({
      ...lab,
      button_name: isAdd ? 0 : 1,
      group_sku_id: groupSkuItem.groupSkuId,
    });

    itemCountMap.forEach((countArr) => {
      const newSumCount = isAdd ? curSumCount + 1 : curSumCount - 1;
      const newIsFull = newSumCount >= groupData.maxNumber;
      if (countArr.groupSkuId === groupSkuItem.groupSkuId) {
        const newCount = isAdd ? countArr.count + 1 : countArr.count - 1;
        countArr.count = newCount;
        // firstAdd = isAdd && (newCount === 1);
        // decToNone = !isAdd && (newCount === 0);
        if (newIsFull) {
          countArr.addIcon = newCount > 0 ? groupSkuAddIcon.selectedUnableIcon : groupSkuAddIcon.unselectedUnableIcon;
        } else {
          countArr.addIcon = newCount > 0 ? groupSkuAddIcon.selectedAbleIcon : groupSkuAddIcon.unselectedAbleIcon;
        }
      } else {
        if (newIsFull) {
          countArr.addIcon = countArr.count > 0 ? groupSkuAddIcon.selectedUnableIcon : groupSkuAddIcon.unselectedUnableIcon;
        } else {
          countArr.addIcon = countArr.count > 0 ? groupSkuAddIcon.selectedAbleIcon : groupSkuAddIcon.unselectedAbleIcon;
        }
      }
    });
    const calPriceParam = itemCountMap.filter((item) => item.count !== 0);
    changeSelectedAttrs(groupData.groupId, calPriceParam, () => {
      // if(firstAdd && current){
      //     // 首次加购需要动画结束之后再赋值，否则会闪烁一下
      //     current.showCountAnim?.()
      //     setTimeout(()=>{
      //         this.setState({
      //             itemCountMap,
      //         })
      //     },1100)
      // } else {
      //     if(decToNone && current){
      //         current.hiddenCountAnim?.()
      //     }
      this.setState({
        itemCountMap,
      });
      // }
    });
  }

  //点击选择sku的逻辑（非复选情况）
  private clickSkuItem = (groupItem: GoodDetailGroupSku) => {
    const {
      groupData, changeSelectedAttrs, t, store
    } = this.props;
    if ((store.getCalStatus() === CALCULATE_PRICE_STATUS.LOADING) || (groupData.repeatable === 1)) {
      return;
    }
    const { itemCountMap } = this.state;
    const status = itemCountMap.find((item) => (item.groupSkuId === groupItem.groupSkuId))?.status;
    const single = groupData.minNumber === 1 && groupData.maxNumber === 1;
    if (groupData.groupSkuList.length === groupData.minNumber) {
      Toast.show(t('cartlayer_select_5'), 2);
      return;
    }
    if ((single && status === 1) || (!single && status === 2)) {
      return;
    }
    switch (true) {
      case single && status === 0:
        itemCountMap.forEach((item) => { item.status = item.groupSkuId === groupItem.groupSkuId ? 1 : 0; });
        break;
      case !single && status === 0:
        itemCountMap.forEach((item) => { if (item.groupSkuId === groupItem.groupSkuId) { item.status = 1; } });
        if (itemCountMap.filter((temp) => (temp.status === 1)).length === groupData.maxNumber) {
          itemCountMap.forEach((item) => { item.status = item.status === 0 ? 2 : 1; });
        }
        break;
      case !single && status === 1:
        itemCountMap.forEach((item) => {
          if (item.groupSkuId === groupItem.groupSkuId || item.status === 2) {
            item.status = 0;
          }
        });
        break;
      default:// 应该包含单选已选中 || 多选不可点击状态
        break;
    }

    itemCountMap.forEach((unReatableItem) => {
      unReatableItem.count = unReatableItem.status === 1 ? 1 : 0;
    });
    const calPriceParam = itemCountMap.filter((item) => item.count !== 0);
    if (calPriceParam) {
      changeSelectedAttrs(groupData.groupId, calPriceParam, () => {
        this.setState({
          itemCountMap,
        });
      });
    }
  }

  // groupSku的文案
  private getItemText = (item: GoodDetailGroupSku) => {
    const { t } = this.props;
    return (item.originPrice.amount > 0 ? `+${item.originPrice.displayText}` : `${t('cartlayer_price_free')}`);
  }

  //判断当前item是否被选中
  private itemStatus = (skuId: number): number => {
    const { itemCountMap } = this.state;
    const status = itemCountMap.find((item) => (item.groupSkuId === skuId))?.status || 0;
    return status;
  }

  /**
     * 非复选状态
     * @param status //0-未选中，1-选中， 2-多选置灰（未选）
     * @returns
     */
  private itemIcon = (skuId: number) => {
    let statusIcon;
    const status = this.itemStatus(skuId);
    if (this.props.groupData.maxNumber === 1 && this.props.groupData.minNumber === 1) {
      statusIcon = status === 1 ? 'assets://shop/icon_multi_sku_single_selected.png' : 'assets://shop/icon_multi_sku_single.png';
    } else {
      statusIcon = status === 1 ? 'assets://shop/icon_multi_sku_multi_selected.png' : (status === 0 ? 'assets://shop/icon_multi_sku_multi.png' : 'assets://shop/icon_multi_sku_multi_unable.png');
    }
    return statusIcon;
  }

  //选择状态文案
  private getStatusText = (): string => {
    const { groupData, t } = this.props;
    const { itemCountMap } = this.state;
    const min = groupData.minNumber;
    const max = groupData.maxNumber;
    const current = itemCountMap.reduce((total, obj) => total + obj.count, 0);
    const left = this.props.groupData.minNumber - current;
    const leftText = current === 0 ? t('cartlayer_select_5a', { pluralCount: min, confirm: min }) : t('cartlayer_select_6b', { pluralCount: left, confirm: left });
    let text = '';
    switch (true) {
      case min === 0:
        text = t('cartlayer_select_10b', { pluralCount: max, confirm: max }); //可选项，最多选max件
        break;
      case min === max:
        text = left === 0 ? t('cartlayer_select_done') : leftText; //必选项，已完成 || 还需选left件 || 仅选min件
        break;
      case min < max && current === 0:
        text = t('cartlayer_select_4', { min, max }); //必选项，最少选min件，最多选max件
        break;
      case min < max && current < min: //必选项，还需要选${left}件
        text = t('cartlayer_select_6b', { pluralCount: left, confirm: left });
        break;
      case min <= current && current < max: //必选项，已完成，还可选${max - current}件
      {
        const num = max - current;
        text = t('cartlayer_select_7b', { pluralCount: num, confirm: num });
        break;
      }
      case min < max && current === max: //必选项，已完成
        text = t('cartlayer_select_done');
        break;
      default:
        text = '🐱未曾设想的情况🐱';
        break;
    }
    return text;
  }

  // group状态样式
  private listUI = (): any => {
    const { groupData } = this.props;
    const { itemCountMap } = this.state;
    const curCount = itemCountMap.reduce((total, obj) => total + obj.count, 0);
    const isChecked = curCount >= groupData.minNumber;
    const { highLight } = this.state;
    let style;
    let backgroundStyle;
    let btnIcon;
    switch (true) {
      case isChecked:
        style = {
          fontFamily: 'KeeTa-Regular',
          fontWeight: 400,
          color: '#222222',
        };
        backgroundStyle = {
          border: '1px solid #CACACA',
          backgroundColor: '#FFFFFF',
        };
        btnIcon = this.props.groupData.minNumber === 0 ? '' : 'assets://shop/icon_multi_sku_group_correct.png';
        break;
      case highLight:
        style = {
          fontFamily: 'KeeTa-Bold',
          fontWeight: 500,
          color: '#D90012',
        };
        backgroundStyle = {
          backgroundColor: '#FFF0F1',
          border: '1px solid #FFF0F1',
        };
        btnIcon = 'assets://shop/icon_multi_sku_group_error.png';
        break;
      default:
        style = {
          fontFamily: 'KeeTa-Bold',
          fontWeight: 500,
          color: '#222222',
        };
        backgroundStyle = {
          backgroundColor: '#FFFABF',
          border: '1px solid #FFFABF',
        };
        btnIcon = 'assets://shop/icon_multi_sku_group_warning.png';
        break;
    }
    return {
      style,
      bgStyle: backgroundStyle,
      icon: btnIcon
    };
  }
}

export default withTranslation('', {
  withRef: true,
})(AttrGroup);
